import React, { useEffect, useState } from 'react'
import PillBtn from '../../components/PillBtn'
import { useTranslate } from '../../components/TranslationText'
import ShowEntryHorseCard from '../../components/showEntry/ShowEntryHorseCard';
import SearchBox from '../../components/SearchBox';
import { useLocation, useNavigate } from 'react-router';
import axiosInstance from '../../axios/axios';
import { eFormButtonsContainer, iconContainer, noDataCard, showIconsContainer, termsTitle } from '../../common/cssclasses';
import NewActionButton from '../../components/ActionButtons/NewActionButton';
import { convertToCamelCase } from '../../helper/convertToCamelCase';
import DraftBtn from '../../components/servicesButtons/DraftBtn';
import SubmitServiceBtn from '../../components/servicesButtons/SubmitServiceBtn';
import { convertDubaiToUTC } from '../../helper/convertDubaiToUTC';
import { createShowEntry, getShowEntryHorses } from './apis/CreateShowEntry';
import UserDropDown from '../../components/showEntry/UserDropDown';
import Loader from '../../components/Loader';

export default function ShowParticipatePage({ toast }) {
    const currentLanguage = localStorage.getItem('eahsLang') ?? 'en';
    const ownerId = localStorage.getItem('currentSubAccountId');
    const { translate } = useTranslate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const showId = searchParams.has("showId")
        ? searchParams.get("showId")
        : "";
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('draft');
    const [horseSearchValue, setHorseSearchValue] = useState('');
    const [maxAllowedHorses, setMaxAllowedHorses] = useState(10);
    const [showDetails, setShowDetails] = useState({});
    const [horsesList, setHorsesList] = useState([]);
    const [loaded, setLoaded] = useState(true);
    const userProfile = JSON.parse(localStorage.getItem("eahsUserProfile"));
    const [profile, setProfile] = useState({
        label:
            !!userProfile &&
            userProfile?.ownerRegisterNo +
            " - " +
            userProfile[`fullName${currentLanguage === "en" ? "" : "Ar"}`],
        value: localStorage.getItem("EAHSUserID"),
    });



    const uniqueCategories = ['draft', ...Array.from(new Set(horsesList.filter((x) => x.status != "" && x.status?.toLowerCase() != "draft").map(horse => horse.status)))];
    const statusToCount = ['pendingreview', 'waitinglist', 'completed', 'pendingpayment'];

    // getShowDetails
    async function getShowDetails(showId) {
        try {
            const res = await axiosInstance.get(`/showentry/getshowentrybyid?id=${showId}&Langauge=${currentLanguage}`);
            if (res.status == 200) {
                const formattedData = {
                    showName: res?.data?.result?.showName,
                    showNameEn: res?.data?.result?.showNameEn,
                    showNameAr: res?.data?.result?.showNameAr,
                    showId: res?.data?.result?.id,
                    showFees: res?.data?.result?.entryFees,
                    maxHorses: res?.data?.result?.maxHorseNumberPerOwner,
                    completedRequestsCount: res?.data?.result?.completedRequestsCount,
                    participationOpend: res?.data?.result?.isShowRegisterStarted,
                    isInternationalShow: res?.data?.result?.isInternational,
                    isEarlyYearling: res?.data?.result?.isEarlyYearling,
                    isLocalRegistrationOpen: res?.data?.result?.isLocalRegistrationOpen ?? false,
                    isInternationalRegistrationOpen: res?.data?.result?.isInternationalRegistrationOpen ?? false,
                    isFoalRegistrationOpen: res?.data?.result?.isFoalRegistrationOpen ?? false,
                }
                setMaxAllowedHorses(formattedData.maxHorses);
                setShowDetails(formattedData);
                setLoaded(true);
            }

        } catch (error) {
            console.error('error in loading Show Details', error);
            setLoaded(true);
        }

    }

    // getHorsesList
    // ShowEntry/GetShowEntryOwnerHorses
    async function getHorseList(ownerId) {
        setLoaded(false);
        try {
            const res = await axiosInstance.post('/ShowEntry/GetShowEntryOwnerHorses', {
                showId: showId,
                ownerId: ownerId,
                createdBy: ownerId,
                langauge: localStorage.getItem('eahsLang')
            })
            if (res.status == 200) {
                const formatedData = res.data.horsesList.map((horse) => ({
                    isSelected: !!!horse?.showHorseStatus ? false : true,
                    name: horse?.name,
                    regNr: horse?.registerNumber,
                    ownerName: horse?.owner,
                    origin: horse?.origin,
                    id: horse?.id,
                    status: horse?.showHorseStatus,
                    birthDate: horse?.birthDate,
                    isRegisterd: horse?.isRegisterd,
                    isEarlyYearlingHorse: horse?.isEarlyYearlingHorse,
                    isQualified: horse?.isQualified,
                    showHorseId: horse?.showHorseId ?? ''
                }));
                const res2 = await getShowEntryHorses(ownerId, showId);
                const participatedHorses = res2.map((horse, index) => ({
                    isSelected: !!!horse?.statusName ? false : true,
                    name: horse?.horseName,
                    regNr: horse?.horseRegisterNo,
                    ownerName: horse?.ownerName ?? '',
                    origin: horse?.horseOrigin,
                    id: horse?.horseId,
                    status: horse?.statusName,
                    birthDate: horse?.horseBirthDate,
                    isRegisterd: horse?.isRegistered,
                    isEarlyYearlingHorse: horse?.isEarlyYearlingHorse,
                    isQualified: true,
                    amount: horse?.amount,
                    categoryName: horse?.categoryName ?? '',
                    showHorseId: horse?.id ?? ''
                }));

                const combinedMap = new Map();

                formatedData.forEach(horse => {
                    combinedMap.set(horse.id, horse);
                });

                participatedHorses.forEach(horse => {
                    if (!combinedMap.has(horse.id)) {
                        combinedMap.set(horse.id, horse);
                    }
                });

                const combinedHorses = Array.from(combinedMap.values());
                setHorsesList(combinedHorses);
                setLoaded(true);
            }
        } catch (error) {
            console.error('Error in getting horses List', error)
            setLoaded(true);
        }
    }


    function addRemoveHorse(id, isRemovingCall = false) {
        const maxReached = (horsesList.filter((x) => x.isSelected == true || statusToCount.includes(x.status)).length >= maxAllowedHorses) && (maxAllowedHorses > 0);
        if (maxReached && !isRemovingCall) {
            toast.error('you Have Reached The maximum Horses to add');
            return;
        }
        setHorsesList((prev) => {
            return prev.map(horse =>
                horse.id === id ? { ...horse, isSelected: !horse.isSelected } : horse
            );
        });
    }
    useEffect(() => {
        getShowDetails(showId);
        getHorseList(ownerId);

    }, [])

    // controlers


    const showBtn = showDetails?.isInternationalShow || showDetails?.isEarlyYearling;
    const horseCardContainer = showDetails?.participationOpend ? 'col-xl-9 col-lg-8 col-md-6  col-sm-12 col-12' : 'col-12';
    const horseCard = showDetails?.participationOpend ? 'col-md-4 col-sm-6 col-12' : 'col-lg-3 col-md-4 col-sm-6 col-12';
    const displayedHorses = horsesList.filter(item => horseSearchValue.toLowerCase() === '' || item.name.toLowerCase().includes(horseSearchValue.toLowerCase()) || item.regNr.toLowerCase().includes(horseSearchValue.toLowerCase()));

    function saveAsDraft() {
        const selectedHorses = horsesList.filter(horse => horse.isSelected);
        createShowEntry('Draft', selectedHorses, showId).then((res) => {
            if (res) {
                toast.success(translate('web.savedAsDraft', 'Saved As Draft'));
                getHorseList(ownerId);
            } else {
                getHorseList(ownerId);
                toast.error(translate('web.unexpectedError', 'Unexpected Error'))
            }
        })
    }

    function submitHorses() {
        const selectedHorses = horsesList.filter(horse => horse.isSelected);
        createShowEntry('Checkout', selectedHorses, showId).then((res) => {
            if (res) {
                toast.success(translate('web.savedSuccessfully', 'Saved Successfully'));
                navigate(`/showEntryCheckoutPage?showId=${showId}&showNameAr=${showDetails.showNameAr}&showNameEn=${showDetails.showNameEn}`);
            } else {
                toast.error(translate('web.unexpectedError', 'Unexpected Error'))
                getHorseList(ownerId);
            }
        })
    }

    if (!loaded) {
        return (
            <Loader />
        )
    }

    return (
        <div className='row'>
            <h2 className={termsTitle + " d-flex align-items-center flex-wrap"}>
                {showDetails?.showName}
                {showBtn &&
                    <div className='ms-auto d-flex align-items-center flex-wrap'>
                        {showDetails?.isFoalRegistrationOpen &&
                            <NewActionButton
                                onClick={() => navigate(`/addEarlyYearlingHorse?showNameAr=${showDetails?.showNameAr}&showNameEn=${showDetails?.showNameEn}&showId=${showId}`)}
                                classNames='btn-outline-secondary w-unset'
                                text={translate('web.addFoalHorse', 'Add Foal')}
                            />
                        }
                        {showDetails?.isInternationalRegistrationOpen &&
                            <NewActionButton
                                onClick={() => navigate(`/addInternationalHorse?showNameAr=${showDetails?.showNameAr}&showNameEn=${showDetails?.showNameEn}&showId=${showId}`)}
                                classNames='btn-danger ms-2 w-unset'
                                text={translate('web.addInterNationalHorse', 'Add International horse')}
                            />
                        }
                    </div>
                }
            </h2>

            <div className={showIconsContainer}>
                <div className={iconContainer}>
                    <i className=" fa-solid fa-sack-dollar C89C66" />
                    <span>{`${translate("web.showFees", "Show Fees")} ${showDetails?.showFees?.toLocaleString('en-US')} ${translate('web.aed', 'AED')}`}</span>
                </div>
                <div className={iconContainer}>
                    <i className=" fa-solid fa-chess-knight C89C66" />
                    <span>{`${showDetails?.maxHorses} ${translate("web.horsesmax", `horses max`)} `}</span>
                </div>
                <div className={iconContainer}>
                    <i className=" fa-solid fa-chess-knight C89C66" />
                    <span>{`${translate('web.selectedHorses', 'Selected Horses')} ( ${horsesList?.filter((x) => x.isSelected == true || statusToCount.includes(x.status)).length} / ${maxAllowedHorses} )`}</span>
                </div>

            </div>
            {/* horse List */}
            {showDetails?.participationOpend &&
                <div className='col-xl-3 col-lg-4 col-md-6  col-sm-12 col-12' style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                    <SearchBox placeholder={translate('web.search', 'search')} value={horseSearchValue} onChange={(e) => setHorseSearchValue(e.target.value)} isPadding isFullWidth={true} />
                    <UserDropDown key={'userDropDown'} profile={profile} setProfile={setProfile} onChange={getHorseList} />
                    {showDetails?.isLocalRegistrationOpen && <>
                        {displayedHorses?.filter(x => x?.isRegisterd).length > 0 &&
                            <h5 className='fw-bold mt-2'>
                                {translate('web.registeredHorses', 'Registeded Horses')}
                            </h5>
                        }
                        {displayedHorses?.filter(x => x?.isRegisterd).map((horse, index) => (
                            <ShowEntryHorseCard toast={toast} showDetails={showDetails} key={`horse${index}`} showId={showId} horse={horse} onClick={() => { addRemoveHorse(horse.id); setActiveTab('draft') }} />
                        ))}
                    </>}
                    {showDetails.isInternationalRegistrationOpen && <>
                        {displayedHorses?.filter(x => !x?.isRegisterd && !x?.isEarlyYearlingHorse).length > 0 &&
                            <h5 className='fw-bold mt-2'>
                                {translate('web.internationalHorses', 'International Horses')}
                            </h5>
                        }
                        {displayedHorses?.filter(x => !x?.isRegisterd && !x?.isEarlyYearlingHorse).map((horse, index) => (
                            <ShowEntryHorseCard toast={toast} showDetails={showDetails} key={`intHorse${index}`} showId={showId} horse={horse} onClick={() => { addRemoveHorse(horse.id); setActiveTab('draft') }} />
                        ))}
                    </>}
                    {showDetails?.isFoalRegistrationOpen && <>
                        {displayedHorses?.filter(x => !x?.isRegisterd && x?.isEarlyYearlingHorse).length > 0 &&
                            <h5 className='fw-bold mt-2'>
                                {translate('web.foalHorse', 'Foal Horses')}
                            </h5>
                        }
                        {displayedHorses?.filter(x => !x?.isRegisterd && x?.isEarlyYearlingHorse).map((horse, index) => (
                            <ShowEntryHorseCard toast={toast} showDetails={showDetails} key={`foalHorse${index}`} showId={showId} horse={horse} onClick={() => { addRemoveHorse(horse.id); setActiveTab('draft') }} />
                        ))}
                    </>}


                </div>
            }
            {/* Horse Tabs */}
            <div className={horseCardContainer}>
                <div className="row  second_section_bar " style={{ cursor: 'pointer', justifyContent: 'flex-start' }}>
                    {uniqueCategories.map((item, index) => (
                        <>
                            <div
                                className={"col-lg-2 col-md-4 col-sm-6 col-8 my-2 text-center px-0"} style={{ minWidth: 250 }}
                                onClick={() => setActiveTab(item)}
                            >

                                <span className={`${activeTab == item ? 'fw-bold' : ''} capatalize_text`} style={{ fontSize: 14 }}>{translate(`web.${convertToCamelCase(item)}`, convertToCamelCase(item))}</span>

                                <div className="service_bar_underline" style={activeTab == item ? { border: '3px solid var(--mainGold)', marginTop: 16 } : {}}></div>
                            </div>
                        </>
                    ))}
                </div>
                {horsesList.filter((x) => x.isSelected == true && (x.status.toLowerCase() == activeTab || x.status == "")).length > 0 && activeTab == 'draft' &&
                    <div className='row ' >

                        {horsesList.filter((x) => x.isSelected == true && (x.status.toLowerCase() == activeTab || x.status == "")).map((horse, index) => (
                            <div className={horseCard}>
                                <ShowEntryHorseCard toast={toast} key={`horse${index}`} showDetails={showDetails} showId={showId} horse={horse} onClick={() => addRemoveHorse(horse.id, true)} isSelectedTab={true} />
                            </div>

                        ))}
                    </div>
                }
                {horsesList.filter((x) => x.isSelected == true && (x.status.toLowerCase() == activeTab || x.status == "")).length == 0 && activeTab == 'draft' &&
                    <div className='row mx-0 mb-main'>
                        <div className={noDataCard}>
                            <span className='red fw-bold'>
                                {translate('web.noDraft', 'No Draft')}
                            </span>
                        </div>
                    </div>
                }
                {horsesList.filter((x) => x.status == activeTab && x.status != 'draft').length > 0 &&
                    <div className='row ' >
                        {horsesList.filter((x) => x.status == activeTab && x.status != 'draft').map((horse, index) => (
                            <div className={horseCard}>
                                <ShowEntryHorseCard toast={toast} key={`horse${index}`} showDetails={showDetails} showId={showId} horse={horse} onClick={() => addRemoveHorse(horse.id)} isSelectedTab={true} />
                            </div>
                        ))}
                    </div>
                }
                {horsesList.filter((x) => x.isSelected == true || statusToCount.includes(x.status)).length >= 0 &&
                    <div className={eFormButtonsContainer}>
                        <DraftBtn key={'draft'} onClick={() => saveAsDraft()} />
                        <SubmitServiceBtn onClick={() => (submitHorses())} />
                    </div>
                }
            </div>
        </div >
    )
}
